import { ref, watch } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useEditor } from '@/stores/editor/editor';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';

export const useDocumentRightPanel = defineStore('documentRightPanel', () => {
  const { jobId } = storeToRefs(useEditor());
  const { jobProfile } = storeToRefs(useCurrentJobProfile());
  const currentTab = ref('comments');

  watch([jobId, jobProfile], ([newJobId, newJobProfile]) => {
    if (newJobId) {
      currentTab.value = 'comments';
    }
    if (newJobProfile) {
      currentTab.value = newJobProfile?.type_key === 'template' ? 'template-usage' : 'comments';
    }
  }, { immediate: true });

  const setCurrentTab = (tab) => {
    currentTab.value = tab;
  };

  return {
    currentTab,
    setCurrentTab,
  };
});
